import { css } from "@microsoft/fast-element";
import { fillColor, getToken, neutralForegroundRest } from "../../design-tokens";

export const backgroundStyles = css`
    :host {
        background-color: ${fillColor};
        color: ${neutralForegroundRest};

        font-family: ${getToken('typography-font-family')};
        font-size: ${getToken('typography-default-font-size')};
        line-height: ${getToken('typography-default-line-height')};
    }
`;
